export type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
export type JsonObject = { [key: string]: JsonValue };

export const unescapeBrackets = (text: string) => text.replace(/\\{/gi, '{').replace(/\\}/gi, '}');

export const escapeBrackets = (text: string) => text.replace(/{/gi, '\\{').replace(/}/gi, '\\}');

const extractMentionSlugsFromJson = (content: string) => {
  const trimmed = content.trim();
  if (!trimmed) return null;
  const firstChar = trimmed[0];
  if (firstChar !== '{' && firstChar !== '[') {
    return null;
  }
  if (!trimmed.includes('"mention"')) {
    return [];
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (!parsed || typeof parsed !== 'object' || !('type' in parsed)) {
      return null;
    }

    const slugs: string[] = [];
    const visit = (node: any) => {
      if (!node || typeof node !== 'object') return;
      if (node.type === 'mention' && node.attrs && typeof node.attrs.id === 'string') {
        slugs.push(node.attrs.id);
      }
      if (Array.isArray(node.content)) {
        node.content.forEach(visit);
      }
    };

    visit(parsed);

    return slugs;
  } catch (_error) {
    return null;
  }
};

const extractMentionSlugsFromHtml = (content: string) => {
  if (!content.includes('data-id="')) return [];

  const slugs: string[] = [];
  const mentionTagRegex = /<mention\b[^>]*\bdata-id="([^"]+)"[^>]*><\/mention>/gi;
  const mentionSpanRegex = /<span\b(?=[^>]*\bdata-type="mention")[^>]*\bdata-id="([^"]+)"[^>]*>.*?<\/span>/gi;

  let match: RegExpExecArray | null = null;

  while ((match = mentionTagRegex.exec(content)) !== null) {
    if (match[1]) {
      slugs.push(match[1]);
    }
  }

  while ((match = mentionSpanRegex.exec(content)) !== null) {
    if (match[1]) {
      slugs.push(match[1]);
    }
  }

  return slugs;
};

export const extractMentionSlugs = (content: string) => {
  const jsonSlugs = extractMentionSlugsFromJson(content);
  if (jsonSlugs) return jsonSlugs;

  const htmlSlugs = extractMentionSlugsFromHtml(content);
  if (htmlSlugs.length > 0) return htmlSlugs;

  if (!content.includes('{{{')) return [];

  const slugs: string[] = [];
  const regex = /\{\{\{(.*?)}}}/g;
  let match: RegExpExecArray | null = null;

  while ((match = regex.exec(content)) !== null) {
    if (!match[1]) continue;
    const [, slug] = match[1].split('|');
    if (slug) {
      slugs.push(slug);
    }
  }

  return slugs;
};
